module.exports = "/_next/static/images/icon-right-678dd43e.png";